import {Component} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent {
  title = 'hyundai-configurator';
  loadingConfigurator = false;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.urlIsConfigurator(event.url)) {
          this.loadingConfigurator = true;
          document.body.style.overflow = 'hidden'; // Disable scrolling
        }
      }

      if (event instanceof NavigationEnd) {
        if (this.urlIsConfigurator(event.url) || this.is404(event.url)) {
          this.loadingConfigurator = false;
          document.body.style.overflow = ''; // Re-enable scrolling
        }
      }
    });
  }

  urlIsConfigurator(url: string) {
    return url.includes('configurator')
  }
  is404(url: string) {
    return url.includes('404')
  }

  get currentPage() {
    return this.router.url;
  }

}
